import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b387f9a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-container" }
const _hoisted_2 = { class: "preview-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder-icon" }, "🎨", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "placeholder-text" }, "テキストを入力", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RawResult = _resolveComponent("RawResult")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" プレビュー画像 "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["preview-image", { 'has-image': _ctx.resultImageUrls[0]?.length > 0 }])
      }, [
        (_ctx.resultImageUrls[0]?.length > 0)
          ? (_openBlock(), _createBlock(_component_RawResult, {
              key: 0,
              images: _ctx.resultImageUrls,
              rounded: _ctx.rounded
            }, null, 8 /* PROPS */, ["images", "rounded"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      ], 2 /* CLASS */)
    ]),
    _createCommentVNode(" リアクションボタン "),
    _withDirectives(_createElementVNode("button", {
      class: _normalizeClass(["reaction-button", {
          'is-loading': _ctx.registrationStatus === 'loading',
          'is-disabled': !_ctx.canReact,
          'is-error': _ctx.isEmojiNameDuplicate
        }]),
      disabled: !_ctx.canReact,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reaction && _ctx.reaction(...args)))
    }, [
      (_ctx.registrationStatus === 'loading')
        ? (_openBlock(), _createElementBlock("span", _hoisted_8))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_ctx.buttonText), 1 /* TEXT */)
    ], 10 /* CLASS, PROPS */, _hoisted_7), [
      [_vShow, _ctx.name]
    ])
  ]))
}